'use client'
import { Table, TableRow, TableHeader, TableCell, ColorButton, ConfirmMessage } from "@/components/ui";
import { getFeedbackId, deleteFeedback } from "@/app/api";
import { defaultFeedback, FeedbackIdResponseType } from "@/types";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export function DeleteFeedback({ id }: { id: string }) {
    const router = useRouter();
    const [loading, setLoading] = useState<boolean>(false)
    const [openMessage, setOpenMessage] = useState<boolean>(false)

    const [feedbackData, setFeedbackData] = useState<FeedbackIdResponseType>()

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await getFeedbackId(id)
                if (response !== undefined) {
                    setFeedbackData(response)
                }
            } catch (e) {
                console.log('Não foi possível buscar o usuário: ', e)
            }
        }

        fetchUser()
    }, [id])


    const feedback = feedbackData || defaultFeedback

    const handleDeleteFeedback = async () => {
        setLoading(true)
        try {
            const res = await deleteFeedback(id)
            if (res) {
                router.back()
            }
        } catch (err) {
            console.log("Erro ao excluir retorno: ", err);
        } finally {
            setLoading(false);
        }
    }



    return (
        <div className="p-8">
            <div className="hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader>Sequência</TableHeader>
                            <TableHeader>Conteúdo</TableHeader>
                            <TableHeader>Autor</TableHeader>
                            <TableHeader>Email do autor</TableHeader>
                            <TableHeader>Status</TableHeader>
                            <TableHeader>Data do envio</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        <TableRow>
                            <TableCell>{feedback.sequence}</TableCell>
                            <TableCell>{feedback.content}</TableCell>
                            <TableCell>
                                {feedback.user?.name ? 'Usuário' : 'Visitante'} - {feedback.user?.name || feedback.visitor?.name}
                            </TableCell>
                            <TableCell>
                                {feedback.user?.email || feedback.visitor?.email || 'Não informado'}
                            </TableCell>
                            <TableCell>
                                {feedback.status === 'PENDING' ? 'Pendente'
                                    : feedback.status === 'APPROVED' ? "Aprovado"
                                        : feedback.status === 'REJECTED' ? 'Rejeitado'
                                            : feedback.status === 'FLAGGED' ? 'Sinalizado'
                                                : 'Pendente'
                                }
                            </TableCell>
                            <TableCell>{new Date(feedback.createdAt).toLocaleDateString()}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableHeader>Observação</TableHeader>
                            <TableCell colSpan={5}>{feedback.observation}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <div className="flex md:hidden">
                <Table>
                    <tbody>
                        <TableRow>
                            <TableHeader>Sequência</TableHeader>
                            <TableCell>{feedback.sequence}</TableCell>
                            <TableHeader>Conteúdo</TableHeader>
                            <TableCell>{feedback.content}</TableCell>
                            <TableHeader>Autor</TableHeader>
                            <TableCell>
                                {feedback.user?.name ? 'Usuário' : 'Visitante'} - {feedback.user?.name || feedback.visitor?.name}
                            </TableCell>
                            <TableHeader>Email do autor</TableHeader>
                            <TableCell>
                                {feedback.user?.email || feedback.visitor?.email || 'Não informado'}
                            </TableCell>
                            <TableHeader>Status</TableHeader>
                            <TableCell>
                                {feedback.status === 'PENDING' ? 'Pendente'
                                    : feedback.status === 'APPROVED' ? "Aprovado"
                                        : feedback.status === 'REJECTED' ? 'Rejeitado'
                                            : feedback.status === 'FLAGGED' ? 'Sinalizado'
                                                : 'Pendente'
                                }
                            </TableCell>
                            <TableHeader>Data do envio</TableHeader>
                            <TableCell>{new Date(feedback.createdAt).toLocaleDateString()}</TableCell>
                            <TableHeader>Observação</TableHeader>
                            <TableCell>{feedback.observation}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <div className="flex flex-col gap-3 p-4  items-center justify-center">
                <ColorButton disabled={loading} onClick={() => setOpenMessage(true)}>
                    {loading ? 'Excluindo...' : 'Excluir'}
                </ColorButton>
            </div>

            <ConfirmMessage
                isOpen={openMessage}
                title="Confirmar exclusão"
                message="Tem certeza que deseja excluir esse retorno? Essa ação não poderá ser desfeita."
                onConfirm={handleDeleteFeedback}
                onCancel={() => setOpenMessage(false)}
            />

        </div>
    )
}